/** Error de lectura local de un archivo, ya normalizado a Error. */
export class FileReadError extends Error {
  name = 'FileReadError';

  constructor(public readonly fileName: string, cause?: string) {
    super(cause ? `No se pudo leer ${fileName}: ${cause}` : `No se pudo leer ${fileName}`);
  }
}

/**
 * Convierte un archivo a data-URI base64.
 *
 * `useBase64` de VueUse rechaza su promesa con el ProgressEvent crudo del
 * FileReader y nadie la consume, asi que el fallo llegaba a Sentry como una
 * promesa sin manejar, sin stack ni mensaje. Ver CANDIDATOS-GPC-AK.
 *
 * @param file Archivo elegido por el usuario.
 * @returns El contenido en base64, con su prefijo data-URI.
 * @throws FileReadError si el navegador no expone FileReader o la lectura falla.
 */
const fileToBase64 = (file: File): Promise<string> => new Promise((resolve, reject) => {
  // Algunos webviews restringidos no exponen FileReader. Ver CANDIDATOS-GPC-A8.
  if (typeof FileReader === 'undefined') {
    reject(new FileReadError(file.name, 'FileReader no disponible'));
    return;
  }

  const reader = new FileReader();
  reader.onload = () => resolve(String(reader.result ?? ''));
  reader.onerror = () => reject(new FileReadError(file.name, reader.error?.message));
  reader.onabort = () => reject(new FileReadError(file.name, 'lectura cancelada'));

  try {
    reader.readAsDataURL(file);
  } catch (error) {
    reject(new FileReadError(file.name, (error as Error)?.message));
  }
});

export default fileToBase64;
